/* eslint-disable max-lines-per-function */
import React, { Fragment } from "react";
import SummaryBar from "../SummaryBar";
import styles from "./AdSummary.scss";
import { AdPrice } from "./AdPrice";
import { AdLocation } from "./AdLocation";
import { AdSummaryBottom } from "./AdSummaryBottom";
import { AdYouTube } from "../AdYouTube";
import { parsePriceString } from "../../../services";


// eslint-disable-next-line complexity
const AdSummary = ({
  ad,
  className,
  hasFavorite,
  adLists,
  isMobile,
  category,
  showDetails,
  bottomSection,
  shouldHilightPromotedAds,
  handleNote,
  featuredLabel
}) => {
  return (
    <div
      className={`${styles.container}  ${className}`}
      style={{ height: `${isMobile ? "100%" : ""}` }}
    >
      <div className={styles.summaryPriceContainer}>
        <div>
          {!bottomSection && (
            <div className={`${styles.info} ${isMobile ? styles.infoMobile : null}`}>
              <span>{ad.postedTime}</span>

              {ad.location && isMobile && <span> | {ad.location}</span>}
            </div>
          )}

          <div className={styles.titleContainer}>
            <span
              className={isMobile ? styles.titleMobile : styles.title}
              title={ad.title}
            >
              {ad.title || ""}
            </span>

            <div className={styles.pricesWrapper}>
              {isMobile ? null : (
                <Fragment>
                  <AdPrice
                    price={ad.price}
                    priceTo={ad.priceTo}
                    previousPrice={ad.previousPrice}
                    isMobile={isMobile}
                    rentPriceType={ad.rentPriceType}
                    priceType={ad.priceType}
                  />
                  {ad.priceM2 && (
                    <div className={styles.priceM2Desktop}>
                      {parsePriceString(Math.round(ad.priceM2))}/m<sup>2</sup>
                    </div>
                  )}

                </Fragment>
              )}
            </div>
          </div>

          {!isMobile && <SummaryBar summary={ad.summary} isMobile={isMobile} />}
        </div>

        {!isMobile ? null : (
          <div>
            <SummaryBar summary={ad.summary} isMobile={isMobile} />
            {featuredLabel && (
              <span className={styles.featuredPropertyInline}>{featuredLabel}</span>
            )}
            <div className={styles.priceMobileContainer}>
              <AdPrice
                price={ad.price}
                priceTo={ad.priceTo}
                className={styles.adPriceMobile}
                previousPrice={ad.previousPrice}
                isMobile={isMobile}
                rentPriceType={ad.rentPriceType}
                priceType={ad.priceType}
              />
              {ad.priceM2 && (
                <div className={styles.priceM2}>
                  {parsePriceString(Math.round(ad.priceM2))}/m<sup>2</sup>
                </div>
              )}
            </div>

            {ad.videoUrl && !adLists.search && (
              <AdYouTube isSearchPage={adLists.search} />
            )}
          </div>
        )}
      </div>
      {!isMobile ? <AdLocation value={ad.location} /> : null}

      {isMobile
        ? null
        : bottomSection && (
          <AdSummaryBottom
            ad={ad}
            adLists={adLists}
            hasFavorite={hasFavorite}
            handleNote={handleNote}
            category={category}
          />
        )}
    </div>
  );
};

AdSummary.defaultProps = {
  hasFavorite: false,
  className: "",
  isMobile: false,
  handleNote: false,
  featuredLabel: null,
};

export default AdSummary;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdSummary/AdSummary.tsx